module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "BHD"
  }, [_vm._v("COLOURING")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Mixing colours plays a vitally important role in cake decorating. Colours bring your cake to life, can set a mood, attract attention or make a statement. Hence, it is important to choose and prepare your tinted buttercream properly. Try to learn a little about colour theory, there’s plenty of information and examples of it on the Internet. Take inspiration from real flowers, the dresses in your wardrobe, wallpapers, gift wrapping and anything beautiful to help you choose colours that will make your cake design spectacular.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD3"
  }, [_c('b', [_vm._v("We have highlighted below the things you should remember when mixing colours.")])]), _vm._v(" "), _c('ul', {
    staticClass: "bull"
  }, [_c('li', {
    staticClass: "top"
  }, [_vm._v("Make sure that your buttercream is at room temperature when tinting, so that the colours blend together.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("Add paste colours a little at a time using a clean cocktail stick (toothpick), and never re-use it. Or tint a small amount of buttercream to create a strong colour, then use that to add to your bigger batch of buttercream so that you can control the strength of colour gradually.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("When tinting buttercream, mix it manually. "), _c('i', [_vm._v("Do not")]), _vm._v(" put it into the mixer to blend it even if it is a huge amount because there is a risk that you will over-beat it.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("Bear in mind that it is normal for buttercream to deepen in colour after a short while, especially with darker colours. Prepare it at least two or three hours ahead of time to allow for any colour change.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("Prepare more than enough tinted buttercream for big projects. You don’t want a part of your cake to be a different colour, do you?")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("If you are aiming for a dark colour, such as black, navy blue or a dark red, you will need to add more colouring gel or paste, so omit the the water or milk to prevent the buttercream becoming too runny, or add them after you have mixed your desired colour.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("If your buttercream is a little yellowish, you can make it whiter by adding a hint of violet or a whitener, such as Sugarflair Super White. If you are aiming for a light shade, whiten the buttercream first then add the desired colour.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("If the colours that you have made are very bright, you can tone them down by adding a hint of black, brown or violet.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("Food colouring comes as powder, liquid, gel or paste. "), _c('i', [_vm._v("Do not")]), _vm._v(" use powder food colour to tint your buttercream directly as it will not dissolve properly. When mixed, it will look as if it is well blended but after a while, the tiny granules will start to dissolve and will show speckles of colours. If this is your only option, we suggest that you dissolve the powder in a very small drop of water, bearing in mind that the more liquid you put in buttercream, the softer it becomes.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("If you are using a liquid food colouring like those in squeeze bottles, it is sometimes hard to control the amount that comes out, especially if you need even less than a drop. You can tint a small amount of buttercream then use that to add colour to your bigger batch, rather than putting colours directly to your buttercream.")]), _vm._v(" "), _c('li', {
    staticClass: "top"
  }, [_vm._v("Food colouring pastes and gels come in many different brands and each has a different concentration and yields a different shade. Whatever brand you have locally, you should always try it first in a small batch so as to prevent wasting the buttercream.")])]), _vm._v(" "), _c('h5', {
    staticClass: "CHD"
  }, [_vm._v("SOME COLOUR MIXING EXAMPLES")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Here’s how to make some of the colours that you might want. Bear in mind that different manufacturers will have different names for their own colours, so only generic names have been given here.")]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Gold = lemon yellow (any bright yellow) + orange")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Turquoise = electric blue + leaf green")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Plum = violet + hint of red")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Navy blue = dark blue + black")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Red = dark pink + orange + red (+ brown/black for deep red)")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Coral = pink + yellow")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Rust = orange + hint of red + hint of brown")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Mauve = violet + yellow")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Avocado = lemon yellow + leaf green + hint of black")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F28.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Black (centre) = brown + black (or black extra)")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F29.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Lavender = pink + violet")])]), _vm._v(" "), _c('div', {
    staticClass: "IMAGE"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-F30.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "CAP1"
  }, [_vm._v("Deep purple = bright red or pink + hint of violet")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ae52e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter14.vue
// module id = 81
// module chunks = 0